import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { __ } from '../../core/utils';
import styles from '../../styles/flyouts/my_company_members/EditMyCompanyMemberToolbarForm.scss';
import Select from '../../components/Select';
import Tooltip from '../../components/Tooltip';
import TaskStatusIcon from '../../assets/images/task-status-15x15.svg';
import classNames from 'classnames';
import { enableAutosave } from '../../redux/actions/general/autosave';
import * as _ from 'lodash';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';

@reduxForm({
  form: 'my_company_members.edit_my_company_member_toolbar',
  enableReinitialize: true,
})
// @connect(
//   (state) => ({
//     dropdown: state.general.dropdown.shown,
//     user_id: state.auth.id,
//     values: getFormValues('tasks.edit_task_toolbar')(state),
//   }),
//   (dispatch) => ({
//     focus: (field) => {
//       dispatch(focus('tasks.edit_task_toolbar', field));
//     },
//   })
// )
class EditMyCompanyMemberToolbarForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progress_percentage: null,
    };
  }

  componentDidMount() {
    this.setState({ progress_percentage: this.props.data.progress_percentage });
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
    this.setState({ progress_percentage: this.props.data.progress_percentage });
  }

  //   @autobind
  //   updateProgress(value) {
  //     this.props.change('progress_percentage', value);

  //     setTimeout(() => this.props.submit(), 10);
  //   }

  //   updateProgressDebounced = _.debounce(
  //     (values) => this.setState({ progress_percentage: values }),
  //     600
  //   );

  render() {
    const { data, user_id, values } = this.props;
    const { is_editor, is_reviewer } = data;
    const { progress_percentage } = this.state;
    const is_assignee = _.includes(_.map(data.assignee, 'id'), user_id);
    const status = _.get(values, 'status');
    // const disabled =
    //   !is_editor || _.includes(['closed', 'canceled'], data.status);

    const statuses = [
      { value: '0', label: __('Deactivated'), color: '#7F7F7D' },
      { value: '1', label: __('Active'), color: '#ADD42A' },
    ];

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <Field
          name='status'
          // disabled={
          //   !(
          //     is_editor ||
          //     (is_reviewer &&
          //       is_assignee &&
          //       _.includes(['not-started', 'started', 'reopened'], status))
          //   )
          // }
          disabled={true}
          component={Select}
          label={__('Status')}
          options={statuses}
          noSort
          dropdown
          top={34}
          left={-40}
          icon={<TaskStatusIcon className={styles.myCompanyMemberStatus} />} // icon in dropdown
          wrapper={(
            // first view in toolbar form
            handleOpen,
            activeItem
          ) => (
            <Tooltip text={__('my-company-members.tooltip.icon.status')}>
              <div
                className={classNames(
                  styles.dropdown,
                  !(
                    is_editor ||
                    (is_reviewer &&
                      is_assignee &&
                      _.includes(
                        ['not-started', 'started', 'reopened'],
                        status
                      ))
                  ) && styles.disabled
                )}
                style={{ background: activeItem.color }}
                onClick={handleOpen}
              >
                <TaskStatusIcon className={styles.myCompanyMemberStatus} />
                <div className={styles.button}>
                  {activeItem.label}
                  <ArrowDownSmallIcon />
                </div>
              </div>
            </Tooltip>
          )}
        />
        {/* <Tooltip text={__('my-company-members-flyout.segment')}>
          <div className={classNames(styles.baloon, styles.set)}>
            {__('my-company-members-flyout.segment')}
          </div>
        </Tooltip>
        <Tooltip text={__('my-company-members-flyout.position')}>
          <div className={classNames(styles.baloon, styles.set)}>
            {__('my-company-members-flyout.position')}
          </div>
        </Tooltip> */}

        {/* <Tooltip
          placement='left'
          text={__('my-company-members-flyout.company-member-status')}
        >
          <div className={classNames(styles.baloon, styles.set)}>
            {__('my-company-members-flyout.status')}
          </div>
        </Tooltip>
        <Tooltip
          placement='left'
          text={__('my-company-members-flyout.company-member-segment')}
        >
          <div className={classNames(styles.baloon, styles.set)}>
            {__('my-company-members-flyout.segment')}
          </div>
        </Tooltip>
        <Tooltip
          placement='left'
          text={__('my-company-members-flyout.company-member-position')}
        >
          <div className={classNames(styles.baloon, styles.set)}>
            {__('my-company-members-flyout.position')}
          </div>
        </Tooltip> */}
      </Form>
    );
  }
}

export default EditMyCompanyMemberToolbarForm;
